/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalNotesResponseDto,
  AdditionalNotesUpsertRequestDto,
  ErrorResponse,
} from '../models/index';
import {
    AdditionalNotesResponseDtoFromJSON,
    AdditionalNotesResponseDtoToJSON,
    AdditionalNotesUpsertRequestDtoFromJSON,
    AdditionalNotesUpsertRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface GetAdditionalNotesByPatientIdRequest {
    patientId: string;
}

export interface UpsertAdditionalNotesRequest {
    additionalNotesUpsertRequestDto: AdditionalNotesUpsertRequestDto;
}

export interface UpsertAdditionalNotesByPatientIdRequest {
    patientId: string;
    additionalNotesUpsertRequestDto: AdditionalNotesUpsertRequestDto;
}

/**
 * 
 */
export class PatientAdditionalNotesApi extends runtime.BaseAPI {

    /**
     * Get patient\'s additional notes
     */
    async getAdditionalNotesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalNotesResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/additional-notes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalNotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s additional notes
     */
    async getAdditionalNotes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalNotesResponseDto> {
        const response = await this.getAdditionalNotesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s additional notes by patient ID
     */
    async getAdditionalNotesByPatientIdRaw(requestParameters: GetAdditionalNotesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalNotesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getAdditionalNotesByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/additional-notes/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalNotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s additional notes by patient ID
     */
    async getAdditionalNotesByPatientId(requestParameters: GetAdditionalNotesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalNotesResponseDto> {
        const response = await this.getAdditionalNotesByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update patient\'s additional notes
     */
    async upsertAdditionalNotesRaw(requestParameters: UpsertAdditionalNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['additionalNotesUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'additionalNotesUpsertRequestDto',
                'Required parameter "additionalNotesUpsertRequestDto" was null or undefined when calling upsertAdditionalNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/additional-notes`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalNotesUpsertRequestDtoToJSON(requestParameters['additionalNotesUpsertRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update patient\'s additional notes
     */
    async upsertAdditionalNotes(requestParameters: UpsertAdditionalNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertAdditionalNotesRaw(requestParameters, initOverrides);
    }

    /**
     * Update patient\'s additional notes by patient ID
     */
    async upsertAdditionalNotesByPatientIdRaw(requestParameters: UpsertAdditionalNotesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalNotesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertAdditionalNotesByPatientId().'
            );
        }

        if (requestParameters['additionalNotesUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'additionalNotesUpsertRequestDto',
                'Required parameter "additionalNotesUpsertRequestDto" was null or undefined when calling upsertAdditionalNotesByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/additional-notes/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalNotesUpsertRequestDtoToJSON(requestParameters['additionalNotesUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalNotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s additional notes by patient ID
     */
    async upsertAdditionalNotesByPatientId(requestParameters: UpsertAdditionalNotesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalNotesResponseDto> {
        const response = await this.upsertAdditionalNotesByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
